import moment from 'moment';
import $ from 'jquery';

export function timeAgo(timestamp) {
  const now = new Date();
  const diffInMillis = now - new Date(timestamp);

  const diffInSeconds = Math.floor(diffInMillis / 1000);
  const diffInMinutes = Math.floor(diffInMillis / (1000 * 60));
  const diffInHours = Math.floor(diffInMillis / (1000 * 60 * 60));
  const diffInDays = Math.floor(diffInMillis / (1000 * 60 * 60 * 24));
  const diffInMonths = Math.floor(diffInMillis / (1000 * 60 * 60 * 24 * 30)); // Approx 30 days per month
  const diffInYears = Math.floor(diffInMillis / (1000 * 60 * 60 * 24 * 365)); // Approx 365 days per year

  if (diffInYears > 0) {
    return `${diffInYears} year${diffInYears > 1 ? 's' : ''} ago`;
  } else if (diffInMonths > 0) {
    return `${diffInMonths} month${diffInMonths > 1 ? 's' : ''} ago`;
  } else if (diffInDays > 0) {
    return `${diffInDays} day${diffInDays > 1 ? 's' : ''} ago`;
  } else if (diffInHours > 0) {
    return `${diffInHours} hour${diffInHours > 1 ? 's' : ''} ago`;
  } else if (diffInMinutes > 0) {
    return `${diffInMinutes} minute${diffInMinutes > 1 ? 's' : ''} ago`;
  } else {
    return `${diffInSeconds} second${diffInSeconds > 1 ? 's' : ''} ago`;
  }
}

export function convertSessionTime(sessionCount) {
  const totalMinutes = sessionCount * 15;

  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  if (hours > 0) {
    return `${hours} hour${hours > 1 ? 's' : ''}, ${minutes} minute${
      minutes !== 1 ? 's' : ''
    }`;
  } else {
    return `${minutes} minute${minutes !== 1 ? 's' : ''}`;
  }
}

export function formatDate(dateStr) {
  const date = new Date(dateStr);
  const formattedDate = date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
  return formattedDate;
}

export function formatDateTime(dateStr) {
  const date = new Date(dateStr);

  const formattedDate = date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });

  const formattedTime = date.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });

  return `${formattedDate}, ${formattedTime}`;
}

export function formatTimeUTCandIST(dateStr) {
  const date = new Date(dateStr);

  const timeUTC = date.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
    timeZone: 'UTC'
  });

  const timeIST = date.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
    timeZone: 'Asia/Kolkata',
  });

  return `${timeUTC} UTC / ${timeIST} IST`;
}

export function formatChatDate(dateStr) {
  const date = new Date(dateStr);
  const now = new Date();

  const IST_OPTIONS = {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
    timeZone: 'Asia/Kolkata'
  };

  const isToday = date.toLocaleDateString('en-GB', { timeZone: 'Asia/Kolkata' }) ===
    now.toLocaleDateString('en-GB', { timeZone: 'Asia/Kolkata' });

  const yesterday = new Date(now);
  yesterday.setDate(yesterday.getDate() - 1);

  const isYesterday = date.toLocaleDateString('en-GB', { timeZone: 'Asia/Kolkata' }) ===
    yesterday.toLocaleDateString('en-GB', { timeZone: 'Asia/Kolkata' });

  if (isToday) {
    return date.toLocaleTimeString('en-GB', IST_OPTIONS);
  }

  if (isYesterday) {
    return `Yesterday, ${date.toLocaleTimeString('en-GB', IST_OPTIONS)}`;
  }

  return date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    timeZone: 'Asia/Kolkata'
  });
}

export function formatMessageTimestamp(dateStr) {
  const date = new Date(dateStr);
  const now = new Date();

  const isToday = date.toDateString() === now.toDateString();
  const isYesterday =
    new Date(now.setDate(now.getDate() - 1)).toDateString() ===
    date.toDateString();

  if (isToday) {
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  }

  if (isYesterday) {
    return `Yesterday, ${date.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
    })}`;
  }

  return date.toLocaleTimeString([], {
    day: '2-digit',
    month: 'short',
     hour: '2-digit', 
     minute: '2-digit'
  });
}

export function formatDuration(minutes) {
  if (!minutes || minutes <= 0) return '0 min';
  const hrs = Math.floor(minutes / 60);
  const mins = minutes % 60;
  if (hrs && mins) return `${hrs} hour${hrs > 1 ? 's' : ''} ${mins} min`;
  if (hrs) return `${hrs} hour${hrs > 1 ? 's' : ''}`;
  return `${mins} min`;
}
export function detectAndSetActiveRange(drp, start, end) {
  let label = 'Custom Range';

  if (start.isSame(moment(), 'day') && end.isSame(moment(), 'day')) label = 'Today';
  else if (start.isSame(moment().subtract(1, 'days'), 'day') && end.isSame(moment().subtract(1, 'days'), 'day')) label = 'Yesterday';
  else if (start.isSame(moment().subtract(6, 'days'), 'day') && end.isSame(moment(), 'day')) label = 'Last 7 Days';
  else if (start.isSame(moment().subtract(29, 'days'), 'day') && end.isSame(moment(), 'day')) label = 'Last 30 Days';
  else if (start.isSame(moment().startOf('month'), 'day') && end.isSame(moment().endOf('month'), 'day')) label = 'This Month';
  else if (
    start.isSame(moment().subtract(1, 'month').startOf('month'), 'day') &&
    end.isSame(moment().subtract(1, 'month').endOf('month'), 'day')
  ) label = 'Last Month';
  else if (start.isSame(moment('2020-01-01'), 'day') && end.isSame(moment(), 'day')) label = 'Till Date';

  // Update active class
  $('.ranges li').removeClass('active');
  $('.ranges li').each(function () {
    if ($(this).text().trim() === label) {
      $(this).addClass('active');
      return false;
    }
  });

  // Hide calendars unless custom
  if (label === 'Custom Range') drp.showCalendars();
  else drp.hideCalendars();
}